import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { AuthService } from '../../../../providers/auth.service';
import { SharedClientService } from '../../shared/services/shared-client.service';
import { UsageStateService } from './store/usage-state.service';
import { PackageStateService } from '../upgrade-or-downgrade/store/package-state.service';

import { UsageState } from './store/usage-state';


export class UsageComponent implements OnInit, OnDestroy {
	public state: UsageState;

	private unsubscribe$ = new Subject();

	constructor(
		private authService: AuthService,
		private sharedClientService: SharedClientService,
		private usageStateService: UsageStateService,
		private packageStateService: PackageStateService) { }

	public ngOnInit(): void {
		this.subscribeToState();
		this.subscribeToPackages();

		this.getCreditStats();
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public reloadData(): void {
		this.usageStateService.resetFirstLoad();
		this.getCreditStats();
	}

	private subscribeToState() {
		this.usageStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.state = state;
			}
		);
	}

	private getCreditStats(): void {
		this.usageStateService.setLoading(true);
		this.sharedClientService.getBillingCreditStats(String(this.authService.userId)).subscribe(
			(entries) => {
				if (entries && entries.length) {
					entries.sort((a, b) => {
						if (a.product_identifier === 'interview-requests') {
							return -1;
						} else if (b.product_identifier === 'interview-requests') {
							return 1;
						}
						return 0;
					});
				}
				this.usageStateService.setEntries(entries);
			}
		);
	}

	private subscribeToPackages() {
		this.packageStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(packageState) => {
				if (packageState.firstLoad && !packageState.loading) {
					this.getCreditStats();
				}
			}
		);
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedClientService }, { type: UsageStateService }, { type: PackageStateService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/usage/usage.component.ts